export default {
    // data is a json in the form
    /* 
    {
        timeStammp: xxx,
        msg: xxx,
        additionalData: {},
        title: xxx,
        group: xxx,
        level: critical, error, info, debug        
    }
    */
    log: function(data) {
        console.log(data.msg);
        if (data.additionalData !== undefined)
            console.log(data.additionalData);
    }
}